export default __webpack_public_path__ + "static/media/checkedIcon.27ed9bbb.svg";